import React, { useState } from "react";
import Footer from "components/footer";
import Header from "components/header";
import ImageNews from "assets/imageNews.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Carousel from "components/carousel";
import ChatLogo from "assets/chat.png";
import SearchLogo from "assets/Vector.png";
import searchIcon from "assets/search.png";
import Blog from "assets/blog.png";
import Pagination from "components/pagination";
import { Link, useLocation, useHistory } from "react-router-dom";
import Breadcrumb from "components/Breadcrumb";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Navigation from "components/Navigation";
import useGlobalStyle from "hooks/useGlobalStyles";
import * as services from "./services";
import usePagination from "utils/usePagination";
import { DateTime } from "luxon";
import Dialog from "components/Dialog";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DateIcon from "@material-ui/icons/Today";
import CloseIcon from "@material-ui/icons/Close";
import { styled } from "@material-ui/core/styles";
import { parseISO, format } from "date-fns";
import { id } from "date-fns/locale";
import parseQueryString from "utils/parseQueryString";
import { newsTab } from "redux/reducers/region";
import { useDispatch, useSelector } from "react-redux";

function News() {
  const dispatch = useDispatch();
  const { news } = useSelector((state) => state.region);
  const settings = {
    slidesToShow: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    infinite: true,
    customPaging: (i) => (
      <div className="ft-slick__dots--custom">
        <div className="loading" />
      </div>
    ),
  };

  const DialogBox = styled(Dialog)(({ theme }) => ({
    "& .MuiDialog-paper": {
      margin: "32px",
      position: "relative",
      overflowY: "visible",
    },
  }));

  const [chances] = useState([
    { id: 0, name: "Peluang Pengadaan Dalam Negeri" },
    { id: 1, name: "Peluang Pengadaan Internasional" },
  ]);

  const resultParams = parseQueryString(useLocation().search);

  const paramsSearch = useLocation().search;

  const history = useHistory();

  const queryObject = React.useMemo(() => resultParams, [resultParams]);

  const [chanceTab, setChanceTab] = useState(0);

  const [params, setParams] = useState({
    q: "",
    page: 1,
    limit: 4,
    total: 10,
    visible: false,
  });

  const [detailResponse, setResponse] = React.useState({
    carousel: [],
    berita: [],
    random: [],
  });

  const [startDate, setStartDate] = useState(new Date());
  const startDay = startDate.toLocaleString("default", { day: "2-digit" });
  const startMonth = startDate.toLocaleString("default", { month: "numeric" });
  const startYear = startDate.toLocaleString("default", { year: "numeric" });
  let startDateFormat = `${startYear}-${startMonth}-${startDay}`;

  const [endDate, setEndDate] = useState(new Date());
  const endDay = endDate.toLocaleString("default", { day: "2-digit" });
  const endMonth = endDate.toLocaleString("default", { month: "numeric" });
  const endYear = endDate.toLocaleString("default", { year: "numeric" });
  let endDateFormat = `${endYear}-${endMonth}-${endDay}`;

  const [total, setPagination] = usePagination();

  React.useEffect(() => {
    services.getCarousel({}, (data) =>
      setResponse((prev) => ({
        ...prev,
        carousel: data?.data,
      }))
    );

    services.getBeritaUsaha(
      {
        judul: params?.q,
        jenis_peluang: news === 0 ? "Dalam Negeri" : "Luar Negeri",
        page: params.q !== "" ? 1 : params.page,
      },
      (data) => (
        setResponse((prev) => ({ ...prev, berita: data.data })),
        setPagination(params.limit, data?.total)
      )
    );

    services.getBeritaUsahaRandom(
      {
        sort: 'random',
        page_size: 3,
        jenis_peluang: news === 0 ? "Dalam Negeri" : "Luar Negeri",
      },
      (data) =>
        setResponse((prev) => ({
          ...prev,
          random: data?.data,
        }))
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.page, news]);

  React.useEffect(() => {
    Boolean(paramsSearch)
      ? dispatch(newsTab(Number(queryObject?.tab)))
      : dispatch(newsTab(Number(0)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [message, setMessage] = React.useState({
    open: false,
    severity: "",
    message: "",
  });

  const onButtonSearch = () => {
    setMessage((prev) => ({ ...prev, open: !message.open }));
  };

  const searchButton = () => {
    services.getBeritaUsaha(
      {
        judul: params?.q,
        jenis_peluang: news === 0 ? "Dalam Negeri" : "Luar Negeri",
        page: 1,
        date_from: startDateFormat,
        date_to: endDateFormat,
      },
      (data) => (
        setResponse((prev) => ({ ...prev, berita: data.data })),
        setPagination(params.limit, data?.total)
      )
    );
    setMessage((prev) => ({ ...prev, open: !message.open }));
  };

  const classes = useGlobalStyle();

  const onUserInput = (e) => {
    const textSearch = e.target.value;
    setParams((prev) => ({ ...prev, q: textSearch }));

    clearTimeout(window.timeout);

    window.timeout = setTimeout(() => {
      setParams((prev) => ({ ...prev, q: textSearch }));
    }, 1000);
  };

  const onReset = (e) => {
    setParams((prev) => ({ ...prev, q: "" }));
    setStartDate(new Date());
    setEndDate(new Date());
    setMessage((prev) => ({ ...prev, open: !message.open }));
    services.getBeritaUsaha(
      {
        judul: "",
        jenis_peluang: news === 0 ? "Dalam Negeri" : "Luar Negeri",
        page: 1,
        date_from: "",
        date_to: "",
      },
      (data) => (
        setResponse((prev) => ({ ...prev, berita: data.data })),
        setPagination(params.limit, data?.total)
      )
    );
  };

  function onEnter(e) {
    if (e.key === "Enter") {
      services.getBeritaUsaha(
        {
          judul: params?.q,
          jenis_peluang: news === 0 ? "Dalam Negeri" : "Luar Negeri",
          page: params.q !== "" ? 1 : params.page,
        },
        (data) => (
          setResponse((prev) => ({ ...prev, berita: data.data })),
          setPagination(params.limit, data?.total)
        )
      );
    }
  }

  return (
    <div className={classes.container}>
      <Navigation />

      <Carousel
        {...settings}
        // dotsClass={classNames('slick-dots',)}
        // className="bg-grey-3 flex flex-1"
        classNameSlickDots="xl:top-72 top-56 bg-grey-3"
      >
        {detailResponse?.carousel?.map(
          (data) =>
            data.status === "1" && (
              <a
                style={{ width: "100%" }}
                href={`${data?.link}`}
                key={data?.id}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={data?.picture_url}
                  alt=""
                  className="w-full h-auto object-cover"
                  style={{ height: 336 }}
                />
              </a>
            )
        )}
      </Carousel>
      <div className="pb-8 bg-grey-3 flex flex-row pt-8 -mt-3 font-montserrat font-medium text-sm text-pink-header">
        <Breadcrumb
          className="lg:px-20 px-6"
          links={[{ name: "Beranda", href: "/" }, { name: "Berita Usaha" }]}
        />
      </div>
      <div className="flex flex-row items-center justify-around mx-auto pt-4 mb-6">
        {chances.map((chance, index) => (
          <div
            key={index}
            className="font-montserrat cursor-pointer flex flex-1 font-medium text-sm text-black-2"
          >
            <div
              className={
                chance.id === news
                  ? "w-full text-center pb-4 border-b-4 border-solid border-pink-header font-montserrat font-bold text-sm text-black-2"
                  : "pb-5 text-center w-full"
              }
              onClick={() => {
                dispatch(newsTab(Number(chance.id)));
                setParams((prev) => ({ ...prev, page: 1 }));
                const search = new URLSearchParams({ tab: chance.id });
                history.replace(`/news?${search}`);
              }}
            >
              {chance.name}
            </div>
          </div>
        ))}
      </div>

      <div className="flex lg:flex-row flex-col flex-1 lg:pb-0 pb-10">
        <div className="lg:w-3/4 w-full">
          <div className="mb-20 w-10/12 mx-auto border border-solid border-grey-3 bg-border-on-pink box-border rounded">
            <div className="flex flex-row justify-between w-11/12 mx-auto py-6 space-x-5">
              <div className="relative w-full">
                <input
                  value={params.q}
                  placeholder="Masukkan kata pencarian"
                  name="search"
                  onChange={(e) => onUserInput(e)}
                  onKeyDown={(e) => onEnter(e)}
                  onFocus={
                    params.visible
                      ? () => setParams((prev) => ({ ...prev }))
                      : () =>
                          setParams((prev) => ({
                            ...prev,
                            visible: true,
                            q: "",
                          }))
                  }
                  className="w-full rounded p-2 font-montserrat text-sm form-input text-black-2 placeholder-gray-400"
                />
                {params.q === "" && (
                  <button
                    className={
                      "absolute right-0 top-1/2 bottom-1/2 my-auto w-10 h-10 flex items-center justify-center focus:outline-none"
                    }
                    type="submit"
                  >
                    <img src={SearchLogo} alt="" />
                  </button>
                )}
                {params.q !== "" && (
                  <button
                    className={
                      "absolute right-0 top-1/2 bottom-1/2 my-auto w-10 h-10 flex items-center justify-center focus:outline-none"
                    }
                    onClick={() => {
                      setParams((prev) => ({ ...prev, q: "", page: 1 }));
                      services.getBeritaUsaha(
                        {
                          judul: "",
                          jenis_peluang:
                            news === 0 ? "Dalam Negeri" : "Luar Negeri",
                          page: 1,
                          date_from: "",
                          date_to: "",
                        },
                        (data) => (
                          setResponse((prev) => ({
                            ...prev,
                            berita: data.data,
                          })),
                          setPagination(params.limit, data?.total)
                        )
                      );
                    }}
                  >
                    <CloseIcon style={{ color: "#595959" }} />
                  </button>
                )}
              </div>
              <button
                onClick={() => onButtonSearch()}
                className="flex rounded bg-pink-header py-2 items-center justify-between px-6 font-montserrat font-medium text-xs text-border-on-pink"
              >
                <div className="pr-3">Cari</div>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.1135 11.0003C3.25123 10.61 3.50666 10.272 3.84456 10.0329C4.18247 9.79376 4.58622 9.66537 5.00016 9.66537C5.4141 9.66537 5.81786 9.79376 6.15576 10.0329C6.49367 10.272 6.74909 10.61 6.88683 11.0003H13.6668V12.3337H6.88683C6.74909 12.724 6.49367 13.062 6.15576 13.3011C5.81786 13.5402 5.4141 13.6686 5.00016 13.6686C4.58622 13.6686 4.18247 13.5402 3.84456 13.3011C3.50666 13.062 3.25123 12.724 3.1135 12.3337H0.333496V11.0003H3.1135ZM7.1135 6.33367C7.25123 5.94331 7.50666 5.60529 7.84456 5.36619C8.18247 5.12709 8.58622 4.9987 9.00016 4.9987C9.41411 4.9987 9.81786 5.12709 10.1558 5.36619C10.4937 5.60529 10.7491 5.94331 10.8868 6.33367H13.6668V7.667H10.8868C10.7491 8.05735 10.4937 8.39538 10.1558 8.63447C9.81786 8.87357 9.41411 9.00197 9.00016 9.00197C8.58622 9.00197 8.18247 8.87357 7.84456 8.63447C7.50666 8.39538 7.25123 8.05735 7.1135 7.667H0.333496V6.33367H7.1135ZM3.1135 1.667C3.25123 1.27664 3.50666 0.938621 3.84456 0.699525C4.18247 0.460429 4.58622 0.332031 5.00016 0.332031C5.4141 0.332031 5.81786 0.460429 6.15576 0.699525C6.49367 0.938621 6.74909 1.27664 6.88683 1.667H13.6668V3.00033H6.88683C6.74909 3.39069 6.49367 3.72871 6.15576 3.96781C5.81786 4.2069 5.4141 4.3353 5.00016 4.3353C4.58622 4.3353 4.18247 4.2069 3.84456 3.96781C3.50666 3.72871 3.25123 3.39069 3.1135 3.00033H0.333496V1.667H3.1135ZM5.00016 3.00033C5.17697 3.00033 5.34654 2.93009 5.47157 2.80507C5.59659 2.68005 5.66683 2.51048 5.66683 2.33366C5.66683 2.15685 5.59659 1.98728 5.47157 1.86226C5.34654 1.73724 5.17697 1.667 5.00016 1.667C4.82335 1.667 4.65378 1.73724 4.52876 1.86226C4.40373 1.98728 4.3335 2.15685 4.3335 2.33366C4.3335 2.51048 4.40373 2.68005 4.52876 2.80507C4.65378 2.93009 4.82335 3.00033 5.00016 3.00033ZM9.00016 7.667C9.17697 7.667 9.34654 7.59676 9.47157 7.47174C9.59659 7.34671 9.66683 7.17714 9.66683 7.00033C9.66683 6.82352 9.59659 6.65395 9.47157 6.52893C9.34654 6.4039 9.17697 6.33367 9.00016 6.33367C8.82335 6.33367 8.65378 6.4039 8.52876 6.52893C8.40373 6.65395 8.3335 6.82352 8.3335 7.00033C8.3335 7.17714 8.40373 7.34671 8.52876 7.47174C8.65378 7.59676 8.82335 7.667 9.00016 7.667ZM5.00016 12.3337C5.17697 12.3337 5.34654 12.2634 5.47157 12.1384C5.59659 12.0134 5.66683 11.8438 5.66683 11.667C5.66683 11.4902 5.59659 11.3206 5.47157 11.1956C5.34654 11.0706 5.17697 11.0003 5.00016 11.0003C4.82335 11.0003 4.65378 11.0706 4.52876 11.1956C4.40373 11.3206 4.3335 11.4902 4.3335 11.667C4.3335 11.8438 4.40373 12.0134 4.52876 12.1384C4.65378 12.2634 4.82335 12.3337 5.00016 12.3337Z"
                    fill="#FEFEFE"
                  />
                </svg>
              </button>
              <DialogBox
                visible={message.open === true}
                onClose={message.open !== true}
                onBackdropClick={onButtonSearch}
              >
                <div className="px-4">
                  <div className="flex items-center justify-end">
                    <button onClick={onButtonSearch} className="px-4 py-2">
                      <CloseIcon />
                    </button>
                  </div>
                  <div className="py-4 flex items-center justify-between border-b border-t border-solid border-welcome">
                    <div className="font-baloo2 font-bold text-base text-black-2">
                      Filter Cari Berita
                    </div>
                  </div>
                  <div className="font-montserrat font-medium text-sm pt-5 pb-4 text-black-2">
                    Filter pencarian berdasarkan waktu berita di-publish
                  </div>
                  <div className="flex w-full gap-3 pb-4 border-b border-solid border-welcome">
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => {
                        const startDay = date.toLocaleString("default", {
                          day: "2-digit",
                        });
                        const startMonth = date.toLocaleString("default", {
                          month: "numeric",
                        });
                        const startYear = date.toLocaleString("default", {
                          year: "numeric",
                        });
                        let startDateFormated = `${startYear}-${startMonth}-${startDay}`;
                        setStartDate(date);
                      }}
                      dateFormat="dd-MM-yyyy"
                      maxDate={new Date()}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      customInput={
                        <div className="w-full">
                          <div className="font-montserrat font-bold text-xs text-black-2 pb-1">
                            Dari Tanggal
                          </div>
                          <div className="flex flex-row justify-between items-center bg-neutral-grey rounded-lg py-2 pr-3 font-semibold text-base font-custom w-full">
                            <input
                              type="text"
                              id="custom"
                              placeholder={`${startDateFormat}`}
                              className="w-11/12 font-montserrat p-2 font-medium text-xs text-black-2 bg-neutral-grey border-0"
                            />
                            <DateIcon className="text-black-2" />
                          </div>
                        </div>
                      }
                    />

                    <DatePicker
                      selected={endDate}
                      onChange={(date) => {
                        const endDay = date.toLocaleString("default", {
                          day: "2-digit",
                        });
                        const endMonth = date.toLocaleString("default", {
                          month: "numeric",
                        });
                        const endYear = date.toLocaleString("default", {
                          year: "numeric",
                        });
                        let endDateFormated = `${endYear}-${endMonth}-${endDay}`;
                        setEndDate(date);
                      }}
                      dateFormat="dd-MM-yyyy"
                      maxDate={new Date()}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      customInput={
                        <div className="w-full">
                          <div className="font-montserrat font-bold text-xs text-black-2 pb-1">
                            Sampai Tanggal
                          </div>
                          <div className="flex flex-row justify-between items-center bg-neutral-grey rounded-lg py-2 pr-3 font-semibold text-base font-custom w-full">
                            <input
                              type="text"
                              id="custom"
                              placeholder={`${endDateFormat}`}
                              className="w-11/12 font-montserrat p-2 font-medium text-xs text-black-2 bg-neutral-grey border-0"
                            />
                            <DateIcon className="text-black-2" />
                          </div>
                        </div>
                      }
                    />
                  </div>
                  <div className="w-full gap-3 flex py-4">
                    <button
                      className="w-full py-2 font-montserrat text-xs font-medium text-border-on-pink bg-black-2 rounded border-solid border border-white"
                      onClick={onReset}
                    >
                      Reset Filter
                    </button>
                    <button
                      className="w-full py-2 font-montserrat text-xs font-medium text-border-on-pink bg-pink-header rounded border-solid border border-pink-header"
                      onClick={searchButton}
                    >
                      Filter Berita
                    </button>
                  </div>
                </div>
              </DialogBox>
            </div>
            <div className="border-b border-solid border-welcome w-full pb-6" />

            {detailResponse?.berita?.map((data) => {
              const dateParse = parseISO(data?.updated_at);
              return (
                data?.status === "1" && (
                  <Link to={`/news_detail/${data?.id}`}>
                    <div className="py-6 border-b border-solid border-welcome flex lg:flex-row flex-col w-11/12 mx-auto">
                      <img
                        src={data?.thumbnail_url}
                        alt=""
                        className="h-auto lg:w-44 w-full"
                      />
                      <div className="lg:pl-6 pl-0 lg:pt-0 pt-4 flex flex-col">
                        <div className="font-baloo2 line-clamp-3 font-bold text-base text-black-2">
                          {data?.judul}
                        </div>
                        <div className="font-montserrat font-medium text-sm text-search pt-2">
                          {format(dateParse, "dd MMM yyyy H:mm", {
                            locale: id,
                          })}
                        </div>
                        <div className="pt-2 border-b-2 border-solid border-pink-header w-2/12" />
                        <div className="font-montserrat font-medium text-xs text-black-2 pt-3 line-clamp-1">
                          {data?.short_deskripsi}
                        </div>
                      </div>
                    </div>
                  </Link>
                )
              );
            })}

            <div className="flex items-center justify-center py-6">
              <Pagination
                count={total}
                page={params.page}
                onChange={(event, page) =>
                  setParams((prev) => ({ ...prev, page: page }))
                }
              />
            </div>
          </div>
        </div>

        <div className="lg:w-4/12 w-full flex flex-col text-left lg:px-0 px-8">
          <div className="font-baloo2 text-left font-bold text-2xl text-black-2">
            Berita Populer
          </div>
          {detailResponse?.random?.map(
            (data) =>
              data?.status === "1" && (
                <Link to={`/news_detail/${data?.id}`}>
                  <div className="flex flex-col w-8/12">
                    <div className="pt-4 font-montserrat font-bold text-sm text-black-2">
                      {data?.judul}
                    </div>
                    <div className="font-montserrat font-medium text-sm text-search pb-4">
                      {DateTime.fromISO(data?.updated_at).toFormat(
                        "dd LLL yyyy hh:mm"
                      )}
                    </div>
                    <div className="border-b border-solid border-welcome" />
                  </div>
                </Link>
              )
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default News;
